export default "__VITE_ASSET__gW20I9Hp__"